import { useState } from 'react';
import PropTypes from 'prop-types';
import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@/bit/components/components.text';
import { sendTaggingInfo } from '@/utils/common';
import styles from './styles';

function Checkbox({
  className,
  id,
  name,
  checked,
  children,
  error,
  onChange,
  formProps,
  hiddenCheckbox = false,
}) {
  const defaultChecked = checked || false;
  const [isChecked, setIsChecked] = useState(defaultChecked);
  const taggingInfo = {
    componentVariation: 'all',
    componentContent: '',
    componentProduct: '',
    componentName: name,
  };
  const handleOnChange = (event) => {
    const { checked: isCheckedAux } = event.target;
    sendTaggingInfo(
      { ...taggingInfo, componentContent: `check-${isCheckedAux}` },
      'change'
    );
    setIsChecked(isCheckedAux);
    onChange(event);
  };

  return (
    <div className={`checkbox-wrapper ${className}`} data-cy={id}>
      <label htmlFor={name} data-cy={`${id}__label`}>
        <input
          {...formProps}
          className={`${hiddenCheckbox ? 'hidden-checkbox' : ''} ${
            error ? 'error' : ''
          } ${isChecked ? 'checked' : ''}`}
          id={name}
          name={name}
          type="checkbox"
          checked={isChecked}
          onChange={handleOnChange}
          data-cy={`${id}__input`}
        />
        {children && (
          <div className={`${hiddenCheckbox ? 'labelText' : ''}`}>
            {children}
          </div>
        )}
      </label>
      {error && (
        <Text
          className="checkbox-wrapper_error"
          text={error}
          color={TEXT_COLOR.RED_DARK}
          kind={TEXT_KIND.SPAN}
          size={TEXT_SIZE.CAPTION3}
          cyData={`${id}__error`}
        />
      )}
      <style jsx>{styles}</style>
    </div>
  );
}
Checkbox.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  error: PropTypes.string,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  className: '',
  checked: false,
  error: '',
  onChange: () => {},
};
export default Checkbox;
